import { render, staticRenderFns } from "./TaxonomySections.vue?vue&type=template&id=1b395010&"
import script from "./TaxonomySections.vue?vue&type=script&lang=ts&"
export * from "./TaxonomySections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports